export enum PetCoverageNameEnum {
    Castration = 'castratie',
    PassingAway = 'overlijden',
    Basic = 'basis',
    Consult = 'consult',
}
